<!-- src/App.vue -->
<template>
  <div>
    <nav>
      <div class="naviWrap" v-if="isLoggedIn">
        <div class="mainNaviWrap">
          <div>
            <img src="@/assets/ddl_logo.png" v-motion-slide-bottom class="pc" />
            <router-link
              to="/dashboard"
              class="naviPart"
              v-motion-slide-bottom
              :delay="100"
            >
              <svg
                width="29"
                height="26"
                viewBox="0 0 29 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.0803 10.8581L19.5676 5.34533L14.5556 0.333336L9.54356 5.34533L4.02906 10.8607L0.111115 14.7778L2.36716 17.0338L6.2842 13.1168L11.7996 7.60137L14.5556 4.84548L17.3115 7.60137L22.8234 13.1141L26.744 17.0338L29 14.7778L25.0803 10.8581Z"
                  fill="white"
                />
                <path
                  d="M4.94769 17.1987V25.671H15.6135V18.9575H19.497V25.671H24.1634V17.196L14.5565 7.58907L4.94769 17.1987Z"
                  fill="white"
                />
              </svg>
              <span>Home</span>
            </router-link>
            <router-link
              to="/attendance/monthlycalendar"
              :class="[
                'naviPart',
                {
                  activeNavi: isActive([
                    '/attendance/monthlycalendar',
                    '/schedule',
                    '/attendance/managers-view',
                    '/attendance/deskreservation',
                    '/attendance/deskcalendar',
                    '/attendance/hubroom',
                  ]),
                  'notify-dot': hasPendingManagerApproval,
                },
              ]"
              v-motion-slide-bottom
              :delay="200"
            >
              <svg
                width="29"
                height="30"
                viewBox="0 0 29 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_108_1986)">
                  <path
                    d="M8.52911 6.61903C9.43155 6.61903 10.1634 5.88721 10.1634 4.98426V2.41202C10.1634 1.50959 9.43155 0.777771 8.52911 0.777771C7.62616 0.777771 6.89435 1.50959 6.89435 2.41202V4.98432C6.89435 5.88721 7.62616 6.61903 8.52911 6.61903Z"
                    fill="white"
                  />
                  <path
                    d="M20.5824 6.61903C21.4849 6.61903 22.2167 5.88721 22.2167 4.98426V2.41202C22.2168 1.50959 21.4849 0.777771 20.5824 0.777771C19.6796 0.777771 18.9477 1.50959 18.9477 2.41202V4.98432C18.9477 5.88721 19.6796 6.61903 20.5824 6.61903Z"
                    fill="white"
                  />
                  <path
                    d="M24.6646 3.10733H23.6532V4.98426C23.6532 6.67793 22.2757 8.05551 20.5825 8.05551C18.8888 8.05551 17.5113 6.67793 17.5113 4.98426V3.10733H11.5998V4.98426C11.5998 6.67793 10.2223 8.05551 8.52912 8.05551C6.8355 8.05551 5.45787 6.67793 5.45787 4.98426V3.10733H4.44647C2.27258 3.10733 0.510193 4.86967 0.510193 7.04361V25.7304C0.510193 27.9043 2.27264 29.6667 4.44647 29.6667H24.6646C26.8385 29.6667 28.6009 27.9043 28.6009 25.7304V7.04361C28.6009 4.86972 26.8385 3.10733 24.6646 3.10733ZM25.503 25.0392C25.503 26.0451 24.6847 26.8634 23.6789 26.8634H5.43219C4.42639 26.8634 3.60807 26.0451 3.60807 25.0392V10.4192H25.5031L25.503 25.0392Z"
                    fill="white"
                  />
                  <path
                    d="M13.7611 21.7543H10.8727V24.6428H13.7611V21.7543Z"
                    fill="white"
                  />
                  <path
                    d="M13.7611 17.2771H10.8727V20.1654H13.7611V17.2771Z"
                    fill="white"
                  />
                  <path
                    d="M9.28423 21.7543H6.3959V24.6428H9.28423V21.7543Z"
                    fill="white"
                  />
                  <path
                    d="M9.28423 17.2771H6.3959V20.1654H9.28423V17.2771Z"
                    fill="white"
                  />
                  <path
                    d="M22.7151 12.7998H19.8268V15.6882H22.7151V12.7998Z"
                    fill="white"
                  />
                  <path
                    d="M18.2388 12.7998H15.35V15.6882H18.2388V12.7998Z"
                    fill="white"
                  />
                  <path
                    d="M18.2388 17.2771H15.35V20.1654H18.2388V17.2771Z"
                    fill="white"
                  />
                  <path
                    d="M22.7151 21.7543H19.8268V24.6428H22.7151V21.7543Z"
                    fill="white"
                  />
                  <path
                    d="M22.7151 17.2771H19.8268V20.1654H22.7151V17.2771Z"
                    fill="white"
                  />
                  <path
                    d="M18.2388 21.7543H15.35V24.6428H18.2388V21.7543Z"
                    fill="white"
                  />
                </g>
              </svg>
              <span>Attendance</span>
            </router-link>
            <router-link
              to="/application/holiday"
              :class="['naviPart', { activeNavi: isActive(['/application/holiday']) }]"
              @click="markRequesterNotificationsAsRead"
              v-motion-slide-bottom
              :delay="300"
            >
              <svg
                version="1.1"
                id="_x32_"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="30"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                xml:space="preserve"
              >
                <g>
                  <rect
                    fill="white"
                    x="141.818"
                    y="394.181"
                    class="st0"
                    width="228.365"
                    height="21.82"
                  ></rect>
                  <rect
                    fill="white"
                    x="141.818"
                    y="305.688"
                    class="st0"
                    width="228.365"
                    height="21.82"
                  ></rect>
                  <rect
                    fill="white"
                    x="141.818"
                    y="217.203"
                    class="st0"
                    width="228.365"
                    height="21.827"
                  ></rect>
                  <rect
                    fill="white"
                    x="262.546"
                    y="128.725"
                    class="st0"
                    width="107.636"
                    height="21.82"
                  ></rect>
                  <path
                    fill="white"
                    d="M411.626,0H222.758c-13.559,0-26.564,5.39-36.152,14.969L68.794,132.788 c-9.59,9.587-14.976,22.596-14.976,36.156v296.5c0,25.67,20.889,46.556,46.56,46.556h311.247c25.667,0,46.556-20.886,46.556-46.556 V46.542C458.182,20.878,437.292,0,411.626,0z M206.252,32.349v104.652c0,11.313-4.405,15.722-15.718,15.722H85.877L206.252,32.349z M432.002,465.444c0,11.237-9.146,20.372-20.376,20.372H100.378c-11.237,0-20.38-9.135-20.38-20.372V175.998h124.554 c13.77,0,24.978-11.207,24.978-24.985V26.184h182.096c11.23,0,20.376,9.127,20.376,20.358V465.444z"
                  ></path>
                </g>
              </svg>
              <span
                :class="{ 'notify-dot': unreadRequesterNotificationsCount > 0 }"
                >Application</span
              >
            </router-link>
            <router-link
              v-if="showApprovalsTab"
              :to="adminLinkPath"
              :class="[
                'naviPart',
                {
                  activeNavi: isActive([
                    '/manage/holidayapproval',
                    '/manage/attendancepdf',
                    '/manage/user',
                    '/manage/company-holidays',
                    '/manage/others',
                  ]),
                },
              ]"
              v-motion-slide-bottom
              :delay="400"
            >
              <svg
                version="1.1"
                width="30"
                id="_x32_"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                xml:space="preserve"
              >
                <g>
                  <path
                    class="st0"
                    d="M255.988,282.537c78.002,0,141.224-63.221,141.224-141.213c0-77.982-63.222-141.213-141.224-141.213 c-77.99,0-141.203,63.23-141.203,141.213C114.785,219.316,177.998,282.537,255.988,282.537z"
                    style="fill: white"
                  ></path>
                  <path
                    class="st0"
                    d="M503.748,468.222C473.826,376.236,364.008,326.139,256,326.139c-108.02,0-217.828,50.098-247.75,142.084 c-4.805,14.74-7.428,29.387-8.25,43.666h512C511.166,497.609,508.553,482.963,503.748,468.222z"
                    style="fill: white"
                  ></path>
                </g>
              </svg>
              <span
                :class="{
                  'has-unread-approvals': unreadApproverNotificationsCount > 0,
                  'notify-dot': unreadApproverNotificationsCount > 0,
                }"
                >Admin</span
              >
            </router-link>
            <a href="#" @click.prevent="logout" class="naviPart logout sp">
              <svg
                id="_x32_"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="29"
                height="30"
                viewBox="0 0 512 512"
              >
                <polygon
                  class="st0"
                  points="368.6 331.5 402.5 365.5 478.1 289.9 512 256 478.1 222.1 402.5 146.5 368.6 180.5 420.1 232 130.9 232 130.9 280 420.1 280 368.6 331.5"
                  fill="white"
                />
                <polygon
                  class="st0"
                  points="48 512 96 512 261.3 512 309.3 512 357.3 512 357.3 464 357.3 432 357.3 352 309.3 352 293.3 352 293.3 448 64 448 64 64 293.3 64 293.3 160 309.3 160 357.3 160 357.3 80 357.3 48 357.3 0 309.3 0 261.3 0 96 0 48 0 0 0 0 48 0 96 0 416 0 464 0 512 48 512"
                  fill="white"
                />
              </svg>
              <span>Logout</span>
            </a>
          </div>
          <div class="pc">
            <a href="#" @click.prevent="logout" class="naviPart logout">
              <svg
                id="_x32_"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="29"
                height="30"
                viewBox="0 0 512 512"
              >
                <polygon
                  class="st0"
                  points="368.6 331.5 402.5 365.5 478.1 289.9 512 256 478.1 222.1 402.5 146.5 368.6 180.5 420.1 232 130.9 232 130.9 280 420.1 280 368.6 331.5"
                  fill="white"
                />
                <polygon
                  class="st0"
                  points="48 512 96 512 261.3 512 309.3 512 357.3 512 357.3 464 357.3 432 357.3 352 309.3 352 293.3 352 293.3 448 64 448 64 64 293.3 64 293.3 160 309.3 160 357.3 160 357.3 80 357.3 48 357.3 0 309.3 0 261.3 0 96 0 48 0 0 0 0 48 0 96 0 416 0 464 0 512 48 512"
                  fill="white"
                />
              </svg>
              <span>Logout</span>
            </a>
            <!--{{ userName }} さん-->
          </div>
        </div>
        <div v-if="isA" class="sp logoSp">
          <img src="@/assets/ddl_logo.png" v-motion-slide-visible-once-bottom />
        </div>
        <div class="subNaviWrap">
          <div v-if="isA">
            <ul>
              <li><router-link to="/dashboard">DashBoard</router-link></li>
            </ul>
          </div>

          <div v-else-if="isB">
            <ul>
              <li v-motion-slide-left>
                <!--<router-link to="/schedule">Schedule</router-link>-->
                <router-link to="/attendance/monthlycalendar">Monthly Calendar</router-link>
              </li>
              <li v-motion-slide-left :delay="100">
                <router-link to="/schedule">Schedule</router-link>
              </li>
              <li v-if="canSeeManagersView" v-motion-slide-left :delay="200">
                <router-link to="/attendance/managers-view" :class="{ 'notify-dot': hasPendingManagerApproval }">Managers' View</router-link>
              </li>
              <li v-motion-slide-left :delay="300">
                <router-link to="/attendance/deskreservation">Desk Reservation</router-link>
              </li>
              <li v-motion-slide-left :delay="400">
                <router-link to="/attendance/deskcalendar">Desk Calendar</router-link>
              </li>
              <li v-motion-slide-left :delay="500">
                <router-link to="/attendance/hubroom">Hub Room</router-link>
              </li>
            </ul>
          </div>

          <div v-else-if="isC">
            <ul>
              <li v-motion-slide-left>
                <router-link to="/application/holiday">Holiday</router-link>
              </li>
              <li v-motion-slide-visible-once-left :delay="100">
                <router-link to="/" class="disableLink" style="color: #bdbdbd">
                  <svg
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 512 512"
                    style="width: 15px; height: 15px; opacity: 0.3"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        class="st0"
                        d="M407.813,212.719h-9.5v-70.406c0.016-39.203-15.984-74.969-41.688-100.625C330.969,15.969,295.203-0.016,256,0 c-39.203-0.016-74.969,15.969-100.625,41.688c-25.703,25.656-41.703,61.422-41.672,100.625v70.406h-9.516 c-34.453,0-62.375,27.938-62.375,62.375v174.531c0,34.438,27.922,62.375,62.375,62.375h303.625 c34.453,0,62.375-27.938,62.375-62.375V275.094C470.188,240.656,442.266,212.719,407.813,212.719z M175.313,142.313 c0.016-22.391,8.984-42.375,23.625-57.063C213.641,70.594,233.625,61.625,256,61.625s42.359,8.969,57.047,23.625 c14.656,14.688,23.625,34.672,23.641,57.063v70.406H175.313V142.313z M274.031,381.672l9.828,63.703H256h-27.859l9.813-63.703 c-15.5-6.922-26.328-22.422-26.328-40.484c0-24.5,19.859-44.375,44.375-44.375c24.5,0,44.375,19.875,44.375,44.375 C300.375,359.25,289.531,374.75,274.031,381.672z"
                      ></path>
                    </g>
                  </svg>
                  Bussiness Trip
                </router-link>
              </li>
              <li v-motion-slide-visible-once-left :delay="200">
                <router-link to="/" class="disableLink" style="color: #bdbdbd">
                  <svg
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 512 512"
                    style="width: 15px; height: 15px; opacity: 0.3"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        class="st0"
                        d="M407.813,212.719h-9.5v-70.406c0.016-39.203-15.984-74.969-41.688-100.625C330.969,15.969,295.203-0.016,256,0 c-39.203-0.016-74.969,15.969-100.625,41.688c-25.703,25.656-41.703,61.422-41.672,100.625v70.406h-9.516 c-34.453,0-62.375,27.938-62.375,62.375v174.531c0,34.438,27.922,62.375,62.375,62.375h303.625 c34.453,0,62.375-27.938,62.375-62.375V275.094C470.188,240.656,442.266,212.719,407.813,212.719z M175.313,142.313 c0.016-22.391,8.984-42.375,23.625-57.063C213.641,70.594,233.625,61.625,256,61.625s42.359,8.969,57.047,23.625 c14.656,14.688,23.625,34.672,23.641,57.063v70.406H175.313V142.313z M274.031,381.672l9.828,63.703H256h-27.859l9.813-63.703 c-15.5-6.922-26.328-22.422-26.328-40.484c0-24.5,19.859-44.375,44.375-44.375c24.5,0,44.375,19.875,44.375,44.375 C300.375,359.25,289.531,374.75,274.031,381.672z"
                      ></path>
                    </g>
                  </svg>
                  Debit Voucher</router-link
                >
              </li>
              <li v-motion-slide-visible-once-left :delay="300">
                <router-link to="/" class="disableLink" style="color: #bdbdbd">
                  <svg
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 512 512"
                    style="width: 15px; height: 15px; opacity: 0.3"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        class="st0"
                        d="M407.813,212.719h-9.5v-70.406c0.016-39.203-15.984-74.969-41.688-100.625C330.969,15.969,295.203-0.016,256,0 c-39.203-0.016-74.969,15.969-100.625,41.688c-25.703,25.656-41.703,61.422-41.672,100.625v70.406h-9.516 c-34.453,0-62.375,27.938-62.375,62.375v174.531c0,34.438,27.922,62.375,62.375,62.375h303.625 c34.453,0,62.375-27.938,62.375-62.375V275.094C470.188,240.656,442.266,212.719,407.813,212.719z M175.313,142.313 c0.016-22.391,8.984-42.375,23.625-57.063C213.641,70.594,233.625,61.625,256,61.625s42.359,8.969,57.047,23.625 c14.656,14.688,23.625,34.672,23.641,57.063v70.406H175.313V142.313z M274.031,381.672l9.828,63.703H256h-27.859l9.813-63.703 c-15.5-6.922-26.328-22.422-26.328-40.484c0-24.5,19.859-44.375,44.375-44.375c24.5,0,44.375,19.875,44.375,44.375 C300.375,359.25,289.531,374.75,274.031,381.672z"
                      ></path>
                    </g>
                  </svg>
                  Credit Voucher</router-link
                >
              </li>
              <li v-motion-slide-visible-once-left :delay="400">
                <router-link to="/" class="disableLink" style="color: #bdbdbd">
                  <svg
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 512 512"
                    style="width: 15px; height: 15px; opacity: 0.3"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        class="st0"
                        d="M407.813,212.719h-9.5v-70.406c0.016-39.203-15.984-74.969-41.688-100.625C330.969,15.969,295.203-0.016,256,0 c-39.203-0.016-74.969,15.969-100.625,41.688c-25.703,25.656-41.703,61.422-41.672,100.625v70.406h-9.516 c-34.453,0-62.375,27.938-62.375,62.375v174.531c0,34.438,27.922,62.375,62.375,62.375h303.625 c34.453,0,62.375-27.938,62.375-62.375V275.094C470.188,240.656,442.266,212.719,407.813,212.719z M175.313,142.313 c0.016-22.391,8.984-42.375,23.625-57.063C213.641,70.594,233.625,61.625,256,61.625s42.359,8.969,57.047,23.625 c14.656,14.688,23.625,34.672,23.641,57.063v70.406H175.313V142.313z M274.031,381.672l9.828,63.703H256h-27.859l9.813-63.703 c-15.5-6.922-26.328-22.422-26.328-40.484c0-24.5,19.859-44.375,44.375-44.375c24.5,0,44.375,19.875,44.375,44.375 C300.375,359.25,289.531,374.75,274.031,381.672z"
                      ></path>
                    </g>
                  </svg>
                  Petty Cash</router-link
                >
              </li>
              <li v-motion-slide-visible-once-left :delay="500">
                <router-link to="/" class="disableLink" style="color: #bdbdbd">
                  <svg
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 512 512"
                    style="width: 15px; height: 15px; opacity: 0.3"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        class="st0"
                        d="M407.813,212.719h-9.5v-70.406c0.016-39.203-15.984-74.969-41.688-100.625C330.969,15.969,295.203-0.016,256,0 c-39.203-0.016-74.969,15.969-100.625,41.688c-25.703,25.656-41.703,61.422-41.672,100.625v70.406h-9.516 c-34.453,0-62.375,27.938-62.375,62.375v174.531c0,34.438,27.922,62.375,62.375,62.375h303.625 c34.453,0,62.375-27.938,62.375-62.375V275.094C470.188,240.656,442.266,212.719,407.813,212.719z M175.313,142.313 c0.016-22.391,8.984-42.375,23.625-57.063C213.641,70.594,233.625,61.625,256,61.625s42.359,8.969,57.047,23.625 c14.656,14.688,23.625,34.672,23.641,57.063v70.406H175.313V142.313z M274.031,381.672l9.828,63.703H256h-27.859l9.813-63.703 c-15.5-6.922-26.328-22.422-26.328-40.484c0-24.5,19.859-44.375,44.375-44.375c24.5,0,44.375,19.875,44.375,44.375 C300.375,359.25,289.531,374.75,274.031,381.672z"
                      ></path>
                    </g>
                  </svg>
                  Late Arrival</router-link
                >
              </li>
              <li v-motion-slide-visible-once-left :delay="600">
                <router-link to="/" class="disableLink" style="color: #bdbdbd">
                  <svg
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 512 512"
                    style="width: 15px; height: 15px; opacity: 0.3"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        class="st0"
                        d="M407.813,212.719h-9.5v-70.406c0.016-39.203-15.984-74.969-41.688-100.625C330.969,15.969,295.203-0.016,256,0 c-39.203-0.016-74.969,15.969-100.625,41.688c-25.703,25.656-41.703,61.422-41.672,100.625v70.406h-9.516 c-34.453,0-62.375,27.938-62.375,62.375v174.531c0,34.438,27.922,62.375,62.375,62.375h303.625 c34.453,0,62.375-27.938,62.375-62.375V275.094C470.188,240.656,442.266,212.719,407.813,212.719z M175.313,142.313 c0.016-22.391,8.984-42.375,23.625-57.063C213.641,70.594,233.625,61.625,256,61.625s42.359,8.969,57.047,23.625 c14.656,14.688,23.625,34.672,23.641,57.063v70.406H175.313V142.313z M274.031,381.672l9.828,63.703H256h-27.859l9.813-63.703 c-15.5-6.922-26.328-22.422-26.328-40.484c0-24.5,19.859-44.375,44.375-44.375c24.5,0,44.375,19.875,44.375,44.375 C300.375,359.25,289.531,374.75,274.031,381.672z"
                      ></path>
                    </g>
                  </svg>
                  Early Leave</router-link
                >
              </li>
              <li v-motion-slide-visible-once-left :delay="700">
                <router-link to="/" class="disableLink" style="color: #bdbdbd">
                  <svg
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 512 512"
                    style="width: 15px; height: 15px; opacity: 0.3"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        class="st0"
                        d="M407.813,212.719h-9.5v-70.406c0.016-39.203-15.984-74.969-41.688-100.625C330.969,15.969,295.203-0.016,256,0 c-39.203-0.016-74.969,15.969-100.625,41.688c-25.703,25.656-41.703,61.422-41.672,100.625v70.406h-9.516 c-34.453,0-62.375,27.938-62.375,62.375v174.531c0,34.438,27.922,62.375,62.375,62.375h303.625 c34.453,0,62.375-27.938,62.375-62.375V275.094C470.188,240.656,442.266,212.719,407.813,212.719z M175.313,142.313 c0.016-22.391,8.984-42.375,23.625-57.063C213.641,70.594,233.625,61.625,256,61.625s42.359,8.969,57.047,23.625 c14.656,14.688,23.625,34.672,23.641,57.063v70.406H175.313V142.313z M274.031,381.672l9.828,63.703H256h-27.859l9.813-63.703 c-15.5-6.922-26.328-22.422-26.328-40.484c0-24.5,19.859-44.375,44.375-44.375c24.5,0,44.375,19.875,44.375,44.375 C300.375,359.25,289.531,374.75,274.031,381.672z"
                      ></path>
                    </g>
                  </svg>
                  Sickness</router-link
                >
              </li>
            </ul>
          </div>

          <div v-else-if="isD">
            <ul>
              <li v-if="hasApprovalRight || isAdmin" v-motion-slide-visible-once-left>
                <router-link to="/manage/holidayapproval">Day Off Approvals</router-link>
              </li>
              <li
                v-if="isAttendanceAdmin"
                v-motion-slide-visible-once-left
                :delay="100"
              >
                <router-link to="/manage/attendancepdf">Attendance Records</router-link>
              </li>
              <li v-if="isAdmin" v-motion-slide-visible-once-left :delay="200">
                <router-link to="/manage/user">User Management</router-link>
              </li>
              <li v-if="isAdmin" v-motion-slide-visible-once-left :delay="300">
                <router-link to="/manage/company-holidays">IEEU Closed</router-link>
              </li>
              <li v-if="isAdmin" v-motion-slide-visible-once-left :delay="400">
                <router-link to="/manage/others">Others</router-link>
              </li>
              <li v-motion-slide-visible-once-left :delay="500">
                <router-link to="/" class="disableLink" style="color: #bdbdbd">
                  <svg
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 512 512"
                    style="width: 15px; height: 15px; opacity: 0.3"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        class="st0"
                        d="M407.813,212.719h-9.5v-70.406c0.016-39.203-15.984-74.969-41.688-100.625C330.969,15.969,295.203-0.016,256,0 c-39.203-0.016-74.969,15.969-100.625,41.688c-25.703,25.656-41.703,61.422-41.672,100.625v70.406h-9.516 c-34.453,0-62.375,27.938-62.375,62.375v174.531c0,34.438,27.922,62.375,62.375,62.375h303.625 c34.453,0,62.375-27.938,62.375-62.375V275.094C470.188,240.656,442.266,212.719,407.813,212.719z M175.313,142.313 c0.016-22.391,8.984-42.375,23.625-57.063C213.641,70.594,233.625,61.625,256,61.625s42.359,8.969,57.047,23.625 c14.656,14.688,23.625,34.672,23.641,57.063v70.406H175.313V142.313z M274.031,381.672l9.828,63.703H256h-27.859l9.813-63.703 c-15.5-6.922-26.328-22.422-26.328-40.484c0-24.5,19.859-44.375,44.375-44.375c24.5,0,44.375,19.875,44.375,44.375 C300.375,359.25,289.531,374.75,274.031,381.672z"
                      ></path>
                    </g>
                  </svg>
                  注文管理</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <router-view
      class="mainView"
      :showApprovalsTab="showApprovalsTab"
      v-motion-fade
      :delay="100"
      style="transform: inherit"
    />
  </div>
</template>

<script setup>
//サブメニュー出しわけ
import { computed } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import { onMounted, ref, onBeforeUnmount } from "vue";
import notificationService from "@/services/notificationService";
import { fetchProfile, fetchManagerPendingApprovals } from "@/services/api";

const showApprovalsTab = ref(false);
const route = useRoute();
const unreadApproverNotificationsCount = ref(0);
const unreadRequesterNotificationsCount = ref(0);
let notificationPollingInterval = null;
const canSeeManagersView = ref(false);
const isTopLevel = ref(false);
const hasPendingManagerApproval = ref(false);

const isA = computed(() => route.path === "/dashboard");
const isB = computed(() =>
  ["/attendance/monthlycalendar", "/schedule", "/attendance/managers-view", "/attendance/deskreservation", "/attendance/deskcalendar", "/attendance/hubroom"].includes(
    route.path
  )
);
const isD = computed(() =>
  ["/manage/holidayapproval", "/manage/attendancepdf", "/manage/user", "/manage/company-holidays", "/manage/others"].includes(route.path)
);
const isC = computed(() => route.path === "/application/holiday");
const isAttendanceAdmin = ref(false);
const isAdmin = ref(false);
const hasApprovalRight = ref(false); // New ref for approval right
const isActive = (paths) => {
  return paths.includes(route.path);
};

const adminLinkPath = computed(() => {
  if (hasApprovalRight.value || isAdmin.value) {
    return "/manage/holidayapproval";
  } else if (isAttendanceAdmin.value) {
    return "/manage/attendancepdf";
  }
  return "/"; // Fallback
});

const fetchUnreadNotificationsCount = async () => {
  if (sessionStorage.getItem("token")) {
    try {
      const response = await notificationService.getUnreadCount();
      unreadRequesterNotificationsCount.value =
        response.requester_notifications_count;
      unreadApproverNotificationsCount.value =
        response.approver_notifications_count;
    } catch (error) {
      console.error("Error fetching unread notifications count:", error);
    }
  }
};

const markRequesterNotificationsAsRead = async () => {
  if (unreadRequesterNotificationsCount.value > 0) {
    await notificationService.markNotificationsAsRead(
      null,
      null,
      "REQUESTER_STATUS_CHANGE"
    );
    await fetchUnreadNotificationsCount(); // UIを即時更新
  }
};

const fetchManagerPendingFlag = async () => {
  if (!sessionStorage.getItem("token")) return;
  try {
    const res = await fetchManagerPendingApprovals();
    hasPendingManagerApproval.value = !!res.data.has_pending;
  } catch (e) {
    console.error("Failed to fetch manager pending approvals flag", e);
    hasPendingManagerApproval.value = false;
  }
};

onMounted(async () => {
  if (sessionStorage.getItem("token")) {
    try {
      // isAttendanceAdmin の状態を localStorage から取得
      isAttendanceAdmin.value =
        localStorage.getItem("isAttendanceAdmin") === "true";
      // admin の状態を localStorage から取得
      isAdmin.value = localStorage.getItem("isAdmin") === "true";
      // hasApprovalRight の状態を localStorage から取得
      hasApprovalRight.value =
        localStorage.getItem("hasApprovalRight") === "true";
      isTopLevel.value = localStorage.getItem("isTopLevel") === "true";

      // Combine conditions for showApprovalsTab
      showApprovalsTab.value =
        hasApprovalRight.value || isAttendanceAdmin.value || isAdmin.value;
      canSeeManagersView.value =
        hasApprovalRight.value ||
        isAttendanceAdmin.value ||
        isAdmin.value ||
        isTopLevel.value;
    } catch (error) {
      console.error("Approvals tab check error:", error);
    }

    // Fetch initial count
    await fetchUnreadNotificationsCount();
    await fetchManagerPendingFlag();
  }
});

onBeforeUnmount(() => {
  // Polling is removed, so no need to clear interval on unmount
});
</script>

<script>
export default {
  name: "App",
  data() {
    return {
      inactivityTimeout: 900000, // 15分 (ミリ秒)
      inactivityTimer: null,
    };
  },
  computed: {
    isLoggedIn() {
      return !!sessionStorage.getItem("token");
    },
    userName() {
      // ログイン時にLoginViewで sessionStorage.setItem("userName", this.username) しているのでその値を取得
      return sessionStorage.getItem("userName") || "ゲスト";
    },
  },
  watch: {
    isLoggedIn(newVal) {
      if (newVal) {
        this.startInactivityTimer();
      } else {
        this.stopInactivityTimer();
      }
    },
  },
  mounted() {
    if (this.isLoggedIn) {
      this.startInactivityTimer();
    }
  },
  beforeUnmount() {
    this.stopInactivityTimer();
  },
  methods: {
    logout() {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userName");
      delete axios.defaults.headers.common["Authorization"];
      this.$router.push("/").then(() => {
        window.location.reload();
      });
    },
    startInactivityTimer() {
      this.stopInactivityTimer(); // 既存のタイマーをクリア
      this.inactivityTimer = setTimeout(() => {
        this.logout();
      }, this.inactivityTimeout);

      // ユーザー操作イベントを監視
      window.addEventListener("mousemove", this.resetInactivityTimer);
      window.addEventListener("keydown", this.resetInactivityTimer);
      window.addEventListener("click", this.resetInactivityTimer);
    },
    resetInactivityTimer() {
      this.startInactivityTimer(); // タイマーをリセット
    },
    stopInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      window.removeEventListener("mousemove", this.resetInactivityTimer);
      window.removeEventListener("keydown", this.resetInactivityTimer);
      window.removeEventListener("click", this.resetInactivityTimer);
    },
  },
};
</script>

<style>
:root {
  --grad: linear-gradient(180deg, #0656a2, #3ca0a6);
  --grad90: linear-gradient(90deg, #0656a2, #3ca0a6);
  --gradCan: linear-gradient(90deg, #c9533f, #ba3a3a);
  --gradYel: linear-gradient(45deg, #cde8ff, #cdf4ff);
  --mainNaviWidth: 80px;
  --subNaviWidth: 180px;
  --totalNaviWidth:260px;
  --lightBlue: #e8f1f6;
  --midLightBlue: #5790bf;
  --blue: #0757a2;
  --green: #399ca6;
  --red: #c9533f;
}
.bgBlu {
  background: var(--blue);
}
.bgGre {
  background: var(--green);
}
* {
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
}
body {
  margin: 0;
  padding-bottom: 5vh;
  scrollbar-color: #888 #f1f1f1;
}

::-webkit-scrollbar-track {
  background: red;
}
::-webkit-scrollbar-thumb {
  background: red;
  border-radius: 6px;
}
::-webkit-scrollbar-thumb:hover {
  background: red;
}

a,
button,
select,
label,
input {
  text-decoration: none;
  cursor: pointer;
}
nav {
  position: relative;
  z-index: 100;
}
h2 {
  margin: 0;
  color: var(--blue);
}
a.disableLink {
  color: #b4b4b4;
  cursor: not-allowed;
  pointer-events: none;
}
.mainNaviWrap {
  width: var(--mainNaviWidth);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background: var(--grad);
  & img {
    margin: 1rem auto 1rem;
    width: 35px;
  }
  & a {
    font-size: 11px;
    color: white;
    font-weight: 600;

    & span {
      display: block;
      margin-top: 5px;
    }
  }
  & > div:first-child {
    display: flex;
    flex-direction: column;
  }
  & .router-link-active,
  & .activeNavi {
    background: var(--lightBlue);
    padding-right: 15px;
    margin-right: -10px;
    padding-left: 5px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;

    & path,
    & rect {
      fill: var(--green) !important;
      transition: 0.1s;
    }
    & span {
      color: var(--green);
    }
  }
}
.naviPart {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  height: var(--mainNaviWidth);

  &.logout {
    opacity: 0.8;
  }
  &.notify-dot {
    position: relative;
    &:after {
      content: "";
      width: 8px;
      height: 8px;
      background: red;
      position: absolute;
      right: 6px;
      top: 6px;
      border-radius: 50%;
      z-index: 101;
    }
  }
  & span.notify-dot {
    position: relative;
    &:after {
      content: "";
      width: 8px;
      height: 8px;
      display: block;
      background: red;
      z-index: 100;
      position: absolute;
      right: -4px;
      top: -4px;
      border-radius: 100px;
    }
  }
}
.subNaviWrap {
  position: fixed;
  top: 0;
  left: var(--mainNaviWidth);
  width: var(--subNaviWidth);
  height: 100vh;
  background: var(--lightBlue);

  & > div {
    padding: 1rem;
  }

  & .subTitle {
    color: var(--blue);
    opacity: 0.5;
    font-size: 13px;
  }

  & ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  & a.notify-dot {
    position: relative;
    &:after {
      content: "";
      width: 8px;
      height: 8px;
      background: red;
      position: absolute;
      right: -10px;
      top: 6px;
      border-radius: 50%;
      z-index: 101;
    }
  }
  & li,
  & a {
    color: var(--blue);
    line-height: 3;
    font-size: 14px;
  }
  & .router-link-active {
    border-bottom: 1px solid var(--blue);
    font-weight: 600;
  }
}
.mainView {
  margin-top: calc(5vh + 1rem);
  width: calc(100% - var(--mainNaviWidth) - var(--subNaviWidth) - 4vw);
  margin-left: calc(var(--mainNaviWidth) + var(--subNaviWidth) + 2vw);
  overflow: auto;
}

/*月の切り替え*/
.monthNavWrap {
  display: flex;

  & button {
    border: none;
    background: none;
    padding: 0 1rem;
    color: var(--blue);
  }
}
/*週末非表示*/
.weekendSwc {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  position: relative;
  margin: 0 0 1rem;
  width: 100%;
  & span {
    color: var(--blue);
    font-size: 14px;
    font-weight: 600;
  }
}
.weekendLabel {
  position: relative;
  display: inline-block;
  width: 69px;
  height: 29px;
  background: #ccc;
  border-radius: 23px;
  cursor: pointer;
  transition: background 0.2s;

  &:after {
    content: "Show";
    position: absolute;
    top: 3px;
    left: 3px;
    padding: 3px 6px;
    background: white;
    border-radius: 100px;
    transition: transform 0.2s;
    font-size: 14px;
    color: gray;
    font-weight: 600;
  }
}
.weekendCheck {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + .weekendLabel {
    background: var(--blue);
  }
  &:checked + .weekendLabel:after {
    color: var(--blue);
    transform: translateX(20px);
    content: "Hide";
  }
}

.pc {
  display: block;
}
.sp {
  display: none;
}
@media (max-width: 768px) {
  .pc {
    display: none;
  }
  .sp {
    display: block;
  }
  .mainNaviWrap {
    width: 100vw;
    height: 80px;
    flex-direction: row;
    justify-content: space-between;
    top: inherit;
    bottom: 0;
    z-index: 100;
    & .naviPart {
      width: 80px;
      align-content: center;
      text-align: center;
      & span {
        font-size: 10px;
      }
    }

    & > div:first-child {
      flex-direction: row;
      justify-content: space-around;
      width: 100%;
    }
    & .router-link-active,
    & .activeNavi {
      padding: 0px;
      margin: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: 10px;
    }
  }
  .mainView {
    width: calc(100% - 2rem);

    margin: 3vh 0;
    padding: 1rem 1rem 5vh;
  }
  .subNaviWrap {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: fit-content;
    background: var(--blue);
    & li,
    & a {
      color: white;
      padding: 0.5rem;
    }
    & ul {
      display: flex;
      width: max-content;
    }
    & .router-link-active {
      border: 1px solid white;
      border-radius: 100px;
    }
    & > div {
      overflow: auto;
      padding: 0.5rem 1rem 0;
    }
  }
  .subTitle {
    display: none;
  }
  .logoSp {
    background: var(--blue);
    text-align: center;
    padding-top: 1rem;
    & img {
      width: 40px;
    }
  }
}
</style>
